import Vue from 'vue'
import Router from 'vue-router'

// 组件命名统一：大驼峰 + 语义化（全部规范）
import HomeView from '@/components/home.vue'
import ItemView from '@/components/item.vue'
import UserView from '@/components/user.vue'
import MyTeam from '@/components/myteam.vue'
import SettingsView from '@/components/settings.vue'
import IncomeView from '@/components/income.vue'
import CopyInvite from '@/components/copy-invite.vue'
import Kj from '@/components/kj.vue'
import Admin from '@/components/admin.vue'
import Admins from '@/components/admins.vue'
import Adminss from '@/components/adminss.vue'
import SbsToken from '@/components/SBSToken.vue' // 你的组件，引入正确
import Tornado from '@/components/Tornado.vue'
import KlinePage from '@/components/KlinePage.vue'
import RemainCount from '@/components/remainCount.vue'
import TornadoCoin from '@/components/tornadoCoin.vue'
import Markt from '@/components/markt.vue'
import Shouyi from '@/components/shouyi.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/user',
    name: 'user',
    component: UserView
  },
  {
    path: '/myteam',
    name: 'myteam',
    component: MyTeam
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView
  },
  {
    path: '/income',
    name: 'income',
    component: IncomeView
  },
  {
    path: '/copy-invite',
    name: 'copyinvite',
    component: CopyInvite
  },
  {
    path: '/kj',
    name: 'kj',
    component: Kj
  },
  {
    path: '/item',
    name: 'item',
    component: ItemView
  },
  {
    path: '/tornado',
    name: 'tornado',
    component: Tornado
  },
  {
    path: '/klinepage',
    name: 'klinepage',
    component: KlinePage
  },
  // ======================
  // 你的 SBSToken 路由（修正为小写横杠规范，更标准）
  // ======================
  {
    path: '/sbs-token',
    name: 'SbsToken',
    component: SbsToken
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin
  },
  
  {
    path: '/admins',
    name: 'admins',
    component: Admins
  },
  {
    path: '/adminss',
    name: 'adminss',
    component: Adminss
  },
  {
    path: '/remain-Count',
    name: 'remainCount',
    component: RemainCount
  },
  {
    path: '/tornado-coin',
    name: 'tornadoCoin',
    component: TornadoCoin
  },
  {
    path: '/markt',
    name: 'markt',
    component: Markt
  }
  ,
  {
    path: '/shouyi',
    name: 'shouyi',
    component: Shouyi
  }
]

export default new Router({
  mode: 'hash',
  routes
})